<template>
  <div @click="showPopup" class="rich-select bank-select">
    <span class="content" v-if="content">{{content}}</span>
    <span class="rich-select-placeholder" v-else>{{placeholder}}</span>
    <i class="rich-select-icon"></i>
  </div>
</template>

<script type="text/ecmascript-6">
import { i18n } from '@/common/utils/i18n'
import { getShopCommonConfig } from '@/api'

export default {
  name: 'BankBranchSelect',
  components: {
  },
  inject: ['rootForm'],
  data () {
    return {
      content: (this.rootForm.value && this.rootForm.value.accountBankBranch) || '',
      options: [],
      placeholder: i18n.gettext('请输入')
    }
  },
  props: {
    value: {
      required: true,
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'bank'
    },
    defaultValue: {
      type: String,
      default: ''
    }
  },
  mounted () {
    this.init()
  },
  watch: {
    'rootForm.value.accountBank': function (newVal, oldVal) {
      if (newVal && oldVal && newVal !== oldVal) {
        this.content = ''
        this.$emit('input', '')
      }
    }
  },
  methods: {
    init () {
      if (!this.value) return
      // 当传入的数据有值且无法与options匹配时，显示传入的默认文案
      if(this.defaultValue){
        this.content = this.defaultValue
      }
      // 获取支行列表
      getShopCommonConfig({
        type: 'bankBranchMap',
        withBankList: 1, // 如果为1，表示bank返回的是有序的数组，0返回对象，对象格式为兼容历史版本
        bankCode: this.rootForm.value.accountBank, // 银行code
      }).then(res => {
        let list = res.data || []
        list.forEach(item => {
          if (item.key+'' === this.value+'') {
            this.content = item.value
          }
        })
      })
    },
    showPopup () {
      let $select = this.$createFullScreenBankBranchSearch().show()
      $select.$on('select', (data) => {
        let { key, value } = data
        this.content = value
        this.options = [{ value: key, text: value }]
        this.$emit('input', key)
        $select.hide()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.bank-select {
  overflow: auto;

  &-btn {
    // padding: 10px;
    text-align: left;
    color: $color-light-grey;
    font-size: $fontsize-medium;
  }

  // 组件使用rich-select需设置disabled属性点击时禁止picker弹出，但不需要disabled的样式
  ::v-deep .rich-select_disabled {
    background-color: #fff
  }

  .panel-wrap {
    width: 100%;
    position: absolute;
    top: 60Px;
    bottom: 0;
    overflow: auto;
    .checkbox {
      padding: 0 20px;
    }
  }

  .content{
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 90%;
  }
}
</style>
